import 'chartjs-adapter-date-fns'
import {
  BarController,
  BarElement,
  CategoryScale,
  Chart,
  Legend,
  LinearScale,
  LineController,
  LineElement,
  PointElement,
  TimeScale,
  Tooltip,
} from 'chart.js'

Chart.register(
  BarController,
  LineController,
  LinearScale,
  CategoryScale,
  TimeScale,
  BarElement,
  PointElement,
  LineElement,
  Tooltip,
  Legend,
)
